export default "__VITE_ASSET__CYkjebK5__"